export default __webpack_public_path__ + "static/media/tuple.959f4672.svg";